import React, { useEffect } from "react";
import history from "../../../Utils/History";
import { useDispatch, useSelector } from "react-redux";
import { Text } from "react-internationalization";
import {
  setStateParams,
  setLoginStateParams,
} from "../../../Redux/Actions/webAppActions";
const PlanTitle = (props) => {
  const dispatch = useDispatch();
  const selectedPlan = useSelector((state) => state.login.selectedPlanName?state.login.selectedPlanName:state.webApp.preEnrollInfo?.planName);
  const prospectEnroll = useSelector((state) => state.login?.prospectEnroll);
  const dpzipCode = useSelector((state) => state.login?.dpzipCode);

  const changePlan = async (event) => {
    event.preventDefault();
    dispatch(setLoginStateParams("deeplink", false));
    dispatch(setStateParams("Submitted", false));
    dispatch(setStateParams("selectedVo", []));
    dispatch(setStateParams("appNum", null));
    dispatch(setStateParams("guestbeneagentAppNum", null));
     dispatch(setStateParams("pendingApplFlag", false));
    if (dpzipCode != "" && dpzipCode != null && dpzipCode != undefined) {
      dispatch(setStateParams("zip", dpzipCode));
    }
    // if (this.props.pendingApplFlag === true) {
    //   await this.props.getZipCodes(
    //     // this.props.preEnrollInfo.permanentAddress.zipCode
    //     this.state.data.permanentAddress.zipCode
    //   );
    //   this.props.setStateParams("zip", this.state.data.permanentAddress.zipCode);
    // }
    // const { permanentAddress } = this.props.preEnrollInfo;
    // const { permanentAddress } = this.state.data;  new comment
    // const stateCd = this.props.stateCd;

    // if (this.props.cardDetails.length === 0) {
    //   let customerId = this.props?.customerId;
    //   //await this.props.getPlans(permanentAddress.zipCode,"",customerId,permanentAddress.state);
    //   await this.props.getPlans(
    //     permanentAddress?.zipCode,
    //     permanentAddress?.countyCd,
    //     customerId,
    //     //permanentAddress?.state
    //     stateCd
    //   );
    // }
    await dispatch(setStateParams("preEnrollInfo", {}));
    if (prospectEnroll !== true) {
      await dispatch(setStateParams("soa", {}));
    }
    dispatch(setStateParams("planType", ""));
    dispatch(setStateParams("selectedProduct", ""));
    dispatch(setStateParams("selectedPlansForCompare",[]))
    history.push("/e-Enroll/select-plan");
  };
  return (
        <div class="plan-title text-center" 
        // pull-left
        >
          <span 
          // className="pull-left"
          >{selectedPlan}</span>
          <a
            // class="teal change-plan"
            class="change-plan"
            href="none"
            onClick={(e) => changePlan(e)}
          >
            <Text id="header.changeMyPlane" />
          </a>
        </div>
  );
};
export default PlanTitle;
